import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt, faTimes, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';

class AdminRoles extends Component {

  standardRow = (role) => {
    this.props.info('AdminRoles.js/standardRow (role)',role);
    return (<Row className="adminRow pointer" onClick={() => this.props.onEdit(role.id)}>
      <Col md={4} className="text-left">
        <FontAwesomeIcon icon={(role['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((role['active']) ? 'iconActive' : 'iconInactive')} />
        {role['role']}
      </Col>
      <Col md={6} className="text-left">{role['description']}</Col>
      {/* <Col md={1} className="text-right"><CustomInput type="switch" id={"switch-active"+role.ID} name={"switch-active"+role.ID} /></Col> */}
      {/* <Col md={2} className="text-right">
        <Button className="mx-1" color="primary" onClick={() => this.props.onEdit(role.ID)}><FontAwesomeIcon icon={faEdit} /></Button>
      </Col> */}
    </Row>
    )
  }

  editRow = (role) => {
    this.props.log('AdminRoles.js/editRow (role)', role);
    return (
      <Row className="editRow adminRow activeTab">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="Role"
                type="text"
                id={"edit-role" + role.id}
                name="role"
                value={this.props.isFieldNull(this.props.editRole.role)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Description"
                type={"edit-text" + role.id}
                id="role-edit-description"
                name="description"
                value={this.props.isFieldNull(this.props.editRole.description)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"role-active" + role.id}
                name="active"
                checked={this.props.isFieldNull(this.props.editRole.active,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"role-active" + role.id}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Role">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(role.id)} title="Delete Role">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={3} className="text-right p-3">
          Assigned Permissions
        </Col>
        <Col md={3} className="text-left py-3 pl-5 maxHpanel">
          {this.props.permissions.map(permission => (
            <div key={permission.id}><Label for={"userPermission_" + permission.id}>
              <Input
                type="checkbox"
                name="permissions"
                id={"userPermission_" + permission.id}
                checked={this.props.isFieldNull(this.props.editRole.permissions.findIndex(i => i === parseInt(permission.id)) > -1,true)}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {permission.permission}
            </Label></div>
          ))}
        </Col>
        <Col md={3} className="text-right p-3">
          Assigned Users
        </Col>
        <Col md={3} className="text-left py-3 pl-5 maxHpanel">
          {this.props.users.map(user => (
            <div key={user.auth0}><Label for={"user_" + user.auth0}>
              <Input
                type="checkbox"
                name="users"
                id={"user_" + user.auth0 + "_" + role.id}
                checked={this.props.isFieldNull([...this.props.users].filter(o => o.roles.findIndex(j => j === role.id) > -1).map(i => i.auth0).findIndex(u => u === user.auth0) > -1,true)}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {user['lastName'] + ', ' + user['firstName']}
            </Label></div>
          ))}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    this.props.info('AdminRoles.js/addRow');
    return (<Row className="py-4 text-left align-items-bottom">
      <Col>
        <Form inline>
          {/* <FormGroup className="pr-2">
            Add New Role
          </FormGroup> */}
          <FormGroup className="px-2">
            <Input
              placeholder="New Role"
              type="text"
              id="role"
              name="role"
              value={this.props.isFieldNull(this.props.newRole.role)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Description"
              type="text"
              id="role-add-description"
              name="description"
              value={this.props.isFieldNull(this.props.newRole.description)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              type="checkbox"
              id="role-active"
              name="active"
              checked={this.props.isFieldNull(this.props.newRole.active,true)}
              onChange={e => this.props.onChange(e)} />
            <Label for="role-active">
              Active
            </Label>
          </FormGroup>
        </Form>
      </Col>
      <Col md={3} className="text-right">
        <Button disabled={this.props.newRole.role === ''} color="primary" onClick={this.props.handleAdd}>Add Role</Button>
      </Col>
    </Row>
    )
  }

  render() {
    this.props.info('AdminRoles.js/render');
    return (
      <Container className="adminContainer" fluid>
        {this.props.roles.map(role => (
          <Fragment key={role.id}>{this.props.editRole.id === role.id ? this.editRow(role) : this.standardRow(role)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );
  }
}

export default AdminRoles;